import React from 'react';
import FinancialAidCalculator from './FinancialAidCalculator';

function App() {
  return (
    <div className="App">
      <FinancialAidCalculator />
    </div>
  );
}

export default App; 